import { Link, useLocation } from "react-router-dom"; // Add useLocation
import { menuItems } from "../Header/consts";
import { legal, ourPresence, socials } from "./consts";
import { Button } from "../ui";
import { SectionCard } from "../SectionCard";
import { routes } from "@/routes/utils";

const Footer = () => {
  const location = useLocation(); // Get current URL

  return (
    <footer className="bg-linear-to-r from-blue-50 to-green-100 relative">
      {location.pathname !== "/contact-us" && (
        <SectionCard className="relative lg:absolute bg-white lg:rounded-[30px] lg:shadow-1xl lg:-top-30 lg:mx-30 2xl:mx-70 lg:py-5 lg:max-w-auto border border-gray-300">
  <div className="grid grid-cols-1 lg:grid-cols-2">
    {/* Left Heading */}
    <div className="text-[32px] lg:text-[52px] font-[700] flex items-center lg:items-start">
      We’d Love to Collaborate
    </div>

    {/* Right Content */}
    <div className="flex flex-col gap-3 mt-3 w-full">
      <span className="text-left ">
        Looking for reliable animal healthcare solutions? <br/>
        At Intron Life Sciences, we’re here to help. Whether you’d like to know more information about our products or have particular requirements, just reach out our team, We are always happy to assist you.
      </span>
      <Link to={"/contact-us"}>
        <Button className="rounded-full">Contact Us</Button>
      </Link>
    </div>
  </div>
</SectionCard>

      )}

      <SectionCard
        className={`lg:max-w-screen-xl md:mx-auto pt-10 ${
          location.pathname === "/contact-us" ? "lg:pt-20" : "lg:pt-40"
        } mb-15`}
      >
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <div className="flex flex-col relative">
            <span className="text-[16px] mb-5 font-[700]">Quick Link</span>
            {menuItems.map((item) => (
              <Link
                to={item.title === "About Us" ? routes.overview : item.to}
                key={item.title}
                className="text-[14px] text-[#707B80] cursor-pointer"
              >
                {item.title}
              </Link>
            ))}
            <div className="w-[0.5px] h-full bg-g-300 absolute right-15 hidden lg:block" />
          </div>
          <div className="flex flex-col relative gap-2">
            <span className="text-[16px] font-[700]">Our Presence</span>
           {ourPresence?.map((item) => (
              <span
                key={item.title}
                className="text-[14px] text-[#707B80] p-0 m-0"
              >
                {item.title === "Vietnam" ? (
                  <a href="https://intronvn.com/" target="_blank" rel="noopener noreferrer">
                    {item.title}
                  </a>
                ) : (
                  <Link to="/contact-us">{item.title}</Link>
                )}
              </span>
            ))}
            <div className="w-[0.5px] h-full bg-g-300 absolute right-15 hidden lg:block" />
          </div>
          <div className="flex flex-col relative gap-2">
            <span className="text-[16px] font-[700]">Legal</span>
            {legal?.map((item) => (
              <span key={item.title} className="text-[14px] text-[#707B80]">
                {item.title}
              </span>
            ))}
            <div className="w-[0.5px] h-full bg-g-300 absolute right-15 hidden lg:block" />
          </div>
          <div className="flex flex-col gap-2">
  <span className="text-[16px] font-[700]">Follow Us</span>
  <div className="flex items-center gap-2"> {/* use flex and small gap */}
    {socials.map(({ href, icon, alt }) => (
      <a
        key={alt}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center h-[36px] w-[36px] cursor-pointer"
      >
        <img
          src={icon}
          alt={alt}
          className="h-[30px] w-[30px] transition-opacity duration-300 ease-in-out"
        />
      </a>
    ))}
  </div>
</div>

        </div>
      </SectionCard>
      <div className="flex items-center justify-center bg-[#3F4D560F] p-3 text-[14px] text-g-300">
         Copyright © 2025 All Rights Reserved To Intron Life Sciences 
      </div>
    </footer>
  );
};

export default Footer;